<div
  class="literature-document-cart"
  *ngIf="dataLoaded && gridData.length !== 0"
>
  <section
    edsPadding
    [edsPaddingLeft]="(isMobile$ | async) ? 'sm' : 'none'"
    [edsPaddingRight]="(isMobile$ | async) ? 'sm' : 'none'"
    edsSpacing="lg"
  >
    <!-- breadcrumb area -->
    <eds-breadcrumbs
      [items]="showBreadcrumb ? breadcrumbItems : null"
      theme="basic"
      edsPadding
      edsPaddingLeft="sm"
    >
    </eds-breadcrumbs>
    <div edsGrid>
      <div class="container" edsPadding edsPaddingTop="lg">
        <!-- My Cart -->
        <eds-title
          edsSpacing="xs"
          [title]="'literature.my-cart' | translate"
          size="h2"
          theme="primary"
          [level]="1"
          [isLight]="true"
        ></eds-title>
        <!-- My Delivery Option -->
        <eds-title
          size="h6"
          theme="basic"
          [isLight]="true"
          [level]="3"
          [title]="'literature.delivery-methods' | translate"
          *ngIf="
            !(gridData.length === hardCopyNotAvailableCount) ||
            !allDocsInCartUnableToDownload
          "
        ></eds-title>
      </div>
    </div>
  </section>

  <div
    edsGrid
    [edsSpacing]="(isHandheld$ | async) === false ? 'xxxl' : 'xxl'"
    edsPadding
    [edsPaddingLeft]="(isMobile$ | async) ? 'sm' : 'none'"
    [edsPaddingRight]="(isMobile$ | async) ? 'sm' : 'none'"
  >
    <div class="container">
      <div edsSpacing="lg">
        <eds-toggle
          [toggleButtons]="toggleButtons"
          (toggleActive)="updateDeliveryOption($event)"
          *ngIf="!allDocsInCartUnableToDownload"
        ></eds-toggle>
      </div>

      <div
        edsFlexbox
        flexDirection="column"
        *ngIf="deliveryOption === '3'"
        edsSpacing="lg"
      >
        <div
          [edsSpacing]="(isHandheld$ | async) === false ? 'xs' : 'sm'"
          edsFlexbox
          flexDirection="column"
          class="email-addrees"
        >
          <div edsSpacing="sm">
            {{ "literature.email-address-label" | translate }}
          </div>
          <div edsSubGrid="layout-1">
            <eds-text-input
              label="{{ 'literature.email-address-placeholder' | translate }}"
              type="type"
              required="required"
              [hideRequiredMark]="true"
              aria-label="inputText"
              [hasHelperText]="true"
              [value]="recipientId"
              (keyup)="checkEmail($event.target.value)"
            ></eds-text-input>
          </div>
          <p
            class="literature-document-cart__email-addrees-error"
            edsSpacing="md"
            *ngIf="!isValid"
          >
            {{ "literature.email-field-error-message" | translate }}
          </p>
        </div>
      </div>

      <div edsFlexbox *ngIf="deliveryOption === '1'">
        <eds-notifications
          [title]="'literature.hard-copy-unavailable-notification' | translate"
          [notificationType]="'warning'"
          [body]="'literature.shipping-message' | translate"
          edsSpacing="xs"
          *ngIf="hardCopyNotAvailableCount"
        ></eds-notifications>
      </div>
      <div
        edsFlexbox
        [alignItems]="
          (isHandheld$ | async) === true ? 'flex-start' : 'baseline'
        "
        justifyContent="space-between"
        edsSpacing="sm"
      >
        <div
          [ngStyle]="{
            display: (isHandheld$ | async) === true ? 'block' : 'flex'
          }"
        >
          <p edsPadding edsPaddingRight="sm" edsSpacing="none">
            {{ "literature.total-items-in-cart" | translate }} :
            {{ itemInCart }}
          </p>
          <ng-container *ngIf="deliveryOption === '1'">
            <p class="separator" *ngIf="(isHandheld$ | async) === false"></p>
            <ng-container *ngIf="overAllQty !== 0; else overAllNA">
              <p
                edsPadding
                [edsPaddingLeft]="
                  (isHandheld$ | async) === false ? 'sm' : 'none'
                "
                edsSpacing="none"
              >
                {{ "literature.total-quantity" | translate }}:
                {{ overAllQty }}
              </p>
            </ng-container>
          </ng-container>
          <ng-template #overAllNA>
            <p
              edsPadding
              [edsPaddingLeft]="(isHandheld$ | async) === false ? 'sm' : 'none'"
            >
              {{ "literature.total-quantity" | translate }}:
              {{ "literature.NA" | translate }}
            </p>
          </ng-template>
        </div>

        <button
          edsButton="secondary"
          size="normal"
          noMargin="true"
          (click)="showEmptyCartDailog($event)"
        >
          <span>{{ "literature.empty-cart" | translate }}</span>
        </button>
      </div>

      <!-- Desktop/Mobile view -->
      <table class="table table--secondary table--overflow">
        <thead class="table__thead">
          <tr class="table__tr">
            <th class="table__th" colspan="1"></th>
            <th class="table__th text-align-left">
              <span class="small">{{
                "literature.cartItemName" | translate
              }}</span>
            </th>
            <th
              *ngIf="deliveryOption === '1'"
              class="table__th literature-document-cart__action-col"
            >
              {{ "literature.quantity" | translate }}
            </th>
            <th
              class="table__th text-align-left literature-document-cart__action-col"
            >
              <span class="small">{{ "literature.action" | translate }}</span>
            </th>
          </tr>
        </thead>
        <tbody class="table__body">
          <tr class="table__tr table__tr--white" *ngFor="let data of gridData">
            <ng-container
              *ngIf="
                data?.mandatoryMaterial?.length ||
                (deliveryOption === '1' && data.displayInMail) ||
                (deliveryOption === '2' && data.displayInDownload) ||
                (deliveryOption === '3' && data.displayInEmail)
              "
            >
              <td
                class="table__td table__td--middle literature-document-cart__image-col text-align-center"
              >
                <div
                  [class.cart-column__image-wrapper]="!isSiteIntl"
                  class="cart-column--{{ imageLayout }}"
                >
                  <ng-container
                    *ngIf="!isSiteIntl"
                    [ngTemplateOutlet]="image"
                    [ngTemplateOutletContext]="{
                      className:
                        imageLayout === 'portrait'
                          ? ' img--full-height img--expand'
                          : '',
                      data: data
                    }"
                  >
                  </ng-container>

                  <ng-container
                    *ngIf="isSiteIntl"
                    [ngTemplateOutlet]="image"
                    [ngTemplateOutletContext]="{
                    data
                  }"
                  >
                  </ng-container>
                </div>
              </td>
              <td class="table__td table__td--middle text-align-left">
                {{ data.fundName }}
              </td>
              <td
                *ngIf="deliveryOption === '1'"
                class="table__td table__td--middle text-align-left literature-document-cart__action-col"
              >
                <ng-container
                  *ngIf="!data.hardCopyNotAvailable; else notApplicableTemplate"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      quantityInput;
                      context: { inputData: data }
                    "
                  >
                  </ng-container>
                </ng-container>
              </td>
              <td
                class="table__td table__td--middle text-align-left literature-document-cart__action-col"
              >
                <eds-link-item
                  *ngIf="!data.mandatoryMaterialPrimary"
                  (click)="deleteDocument(data, $event)"
                  title="{{
                    'literature.lit-sticky-delete-button' | translate
                  }}"
                ></eds-link-item>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
      <div edsFlexbox edsPadding edsPaddingTop="lg">
        <div edsPadding edsPaddingRight="sm">
          <button
            edsButton="secondary"
            size="normal"
            [noMargin]="true"
            (click)="goToLiterature()"
          >
            <span>{{ "literature.lit-continue-browse" | translate }}</span>
          </button>
        </div>
        <button
          edsButton="primary"
          size="normal"
          data-analytics-no-event="true"
          [noMargin]="true"
          [disabled]="
            (deliveryOption === '1' &&
              (gridData.length === hardCopyNotAvailableCount ||
                isValidCartQty)) ||
            (deliveryOption === '3' && isDisabled)
          "
          (click)="handleDelivery()"
        >
          <span>{{ btnLabel2 }}</span>
        </button>
      </div>
    </div>
  </div>
  <ng-template #notApplicableTemplate>
    {{ "literature.NA" | translate }}
  </ng-template>
  <ng-template let-data="inputData" #quantityInput>
    <eds-text-input
      name="quantity"
      [type]="'text'"
      ariaLabel="quantity"
      [value]="data.reOrderQty ? data.reOrderQty : data.quantity"
      (inputTextChange)="updateQuantity(data.docId, $event)"
      [pattern]="numberPattern"
      (input)="onQuantityInput($event, data)"
      [hasQuantity]="true"
      required="required"
      [hideRequiredMark]="true"
      [invalid]="data?.isInvalidQty"
      [invalidText]="data?.invalidQtyMessage"
    >
    </eds-text-input>
  </ng-template>
</div>

<ft-literature-dialog
  [dialogId]="modalIdValue"
  [modalIdEnum]="'cartModal'"
  [dynamicBodyTextToAppend]="dynamicBodyTextToAppend"
  [dialogMandatoryMaterials]="dialogMandatoryMaterials"
  (dialog)="closeModal($event)"
  (emptyCart)="emptyCart($event)"
  (modalClosedInternally)="handleEdsCloseEvent($event)"
  (removeMandatoryItems)="removeMandatoryMaterial()"
  (modalClose)="closeModal('cartModal')"
  data-analytics-no-event="true"
></ft-literature-dialog>

<ng-container *ngIf="dataLoaded && gridData.length === 0">
  <section
    edsPadding
    [edsPaddingLeft]="(isMobile$ | async) ? 'sm' : 'none'"
    [edsPaddingRight]="(isMobile$ | async) ? 'sm' : 'none'"
    edsSpacing="lg"
  >
    <div edsGrid>
      <div class="container" edsPadding edsPaddingTop="lg">
        <!-- Your Cart -->
        <p edsSpacing="xs" class="pre-title">
          {{ "literature.your-cart" | translate }}
        </p>
        <p edsSpacing="xs">
          {{ "literature.no-items" | translate }}
          <a
            (click)="goToLiterature()"
            [ngStyle]="{
              cursor: 'pointer'
            }"
          >
            <span>{{ "literature.literature" | translate }}</span>
          </a>
          {{ "literature.select-materials" | translate }}
        </p>
      </div>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="!dataLoaded">
  <ngx-skeleton-loader
    edsCol
    [count]="10"
    animation="pulse"
    [theme]="{
      'background-color': '#e8e8e8',
      'border-radius': '0',
      height: 'var(--space-xxl)'
    }"
  ></ngx-skeleton-loader>
</ng-container>
<ng-template #image let-className="className" let-data="data">
  <eds-image
    [className]="'img--grey-border img--full-width' + className"
    *ngIf="data?.imageUrl"
    [imgSrc]="data?.imageUrl"
    [altText]=""
    class="spacingWrapper"
    (imageLoad)="onImageLoad($event)"
  >
  </eds-image>
  <eds-icon
    *ngIf="!data?.imageUrl"
    [type]="data?.fileExtension"
    size="normal"
  ></eds-icon>
</ng-template>
